import React, { useEffect, useState } from "react";
import { db } from "../../services/firebase";
import {
collection,
getDocs,
orderBy,
query,
} from "firebase/firestore";
import { ReactComponent as ClientesIcon } from '../../assets/icons/ClientesIcon.svg';
import { ReactComponent as EventosIcon } from '../../assets/icons/EventosIcon.svg';
import { ReactComponent as MenuIcon } from '../../assets/icons/MenuIcon.svg';
import { ReactComponent as MiembrosIcon } from '../../assets/icons/MiembrosIcon.svg';
import { ReactComponent as VentasIcon } from '../../assets/icons/VentasIcon.svg';
import { ReactComponent as GreenCheck } from '../../assets/icons/GreenCheck.svg';
import { ReactComponent as RedCheck } from '../../assets/icons/RedCheck.svg';
import { ReactComponent as ContractIcon } from '../../assets/icons/ContractIcon.svg';
import LoadingSpinner from '../LoadingSpinner'
import EmptyState from '../EmptyState';
import { useNavigate } from "react-router-dom";
const Eventos = () => {
const [eventos, setEventos] = useState([]);
const [isLoading, setIsLoading] = useState(true)
const [imagesLoaded, setImagesLoaded] = useState(false);
useEffect(() => {
if (eventos.length === 0) {
setImagesLoaded(true);
return;
}
let loadedCount = 0;
const totalImages = eventos.filter(e => e.imagen).length;
if (totalImages === 0) {
setImagesLoaded(true);
return;
}
eventos.forEach(evento => {
if (!evento.imagen) return;
const img = new Image();
img.src = evento.imagen;
img.onload = () => {
loadedCount += 1;
if (loadedCount === totalImages) {
setImagesLoaded(true);
}
};
img.onerror = () => {
loadedCount += 1;
if (loadedCount === totalImages) {
setImagesLoaded(true);
}
};
});
}, [eventos]);
useEffect(() => {
const fetchEventos = async () => {
let combinedList = [];
const colecciones = ["eventos", "demostraciones", "degustaciones"];
try {
for (const coleccionNombre of colecciones) {
const q = query(
collection(db, coleccionNombre),
orderBy("fechaCreacion", "desc")
);
const querySnapshot = await getDocs(q);
const docsList = querySnapshot.docs.map((doc) => {
const data = doc.data();
const baseDoc = {
id: doc.id,
...data,
tipo: coleccionNombre,
};
if (coleccionNombre === "degustaciones") {
return {
...baseDoc,
titulo: "Degustación",
descripcion: "",
imagen: null,
precio: null,
};
} else if (coleccionNombre === "demostraciones") {
return {
...baseDoc,
imagen: null,
};
}
return baseDoc;
});
combinedList = combinedList.concat(docsList);
}
combinedList.sort((a, b) => {
const fechaA = (a.fechaCreacion?.toDate() || new Date(0));
const fechaB = (b.fechaCreacion?.toDate() || new Date(0));
return fechaB - fechaA;
});
setEventos(combinedList);
} catch (error) {
console.error("Error obteniendo documentos combinados:", error);
} finally {
setIsLoading(false);
}
};
fetchEventos();
}, []);
const recientes = eventos.slice(0, 4);
const formatearFecha = (fecha) => {
if (!fecha) return "-";
let date;
if (fecha.toDate) {
date = fecha.toDate();
} else {
date = new Date(fecha);
}
return `El ${date.toLocaleDateString("es-AR")} a las ${date.toLocaleTimeString("es-AR", {
hour: "2-digit",
minute: "2-digit",
hour12: false,
})}`;
};
const formatearFechasYHora = (fechas, hora) => {
if (!fechas || fechas.length === 0) return '-';
const fechasAgrupadas = fechas.reduce((acc, fechaString) => {
const fecha = new Date(fechaString);
const mes = fecha.toLocaleDateString('es-ES', { month: 'long' });
const dia = fecha.getDate();
if (!acc[mes]) {
acc[mes] = [];
}
acc[mes].push(dia);
return acc;
}, {});
const meses = Object.keys(fechasAgrupadas);
let resultado = '';
if (meses.length === 1) {
const dias = fechasAgrupadas[meses[0]];
const diasFormateados = dias.map(d => `${d}`).join(', ').replace(/,([^,]*)$/, ' y$1');
resultado = `${diasFormateados} de ${meses[0]}`;
} else {
const partes = meses.map(mes => {
const dias = fechasAgrupadas[mes];
return `${dias[0]} de ${mes}`;
});
resultado = partes.join(', ').replace(/,([^,]*)$/, ' y$1');
}
const [horas, minutos] = hora.split(':');
let horaFormateada = '';
if (minutos === '00') {
horaFormateada = `${horas} hs.`;
} else {
horaFormateada = `${hora} hs.`;
}
return `${resultado}, ${horaFormateada}`;
};
const formatearPrecio = (precio) => {
const precioNumerico = parseFloat(precio);
if (precio === null || isNaN(precioNumerico)) {
return '-';
}
return precioNumerico.toLocaleString('es-ES', {
minimumFractionDigits: 0,
maximumFractionDigits: 2
});
};
const navigate = useNavigate();
const handleEventClick = (id) => {
navigate(`/eventos/${id}`);
};
const handleEditClick = (id, tipo) => {
if (tipo === 'demostraciones') {
navigate(`/demostraciones/editar/${id}`);
} else if (tipo === 'degustaciones') {
navigate(`/degustaciones/editar/${id}`);
} else {
navigate(`/eventos/editar/${id}`);
}
};
const handleSimpleDocClick = (id, tipo) => {
    // Esta función se utiliza para navegar a la vista de detalles/post mortem para tipos simples
    navigate(`/${tipo}/${id}`);
};
const todasLasFechasPasaron = (fechas) => {
if (!fechas || fechas.length === 0) {
return false;
}
const ahora = new Date();
return fechas.every(fechaString => {
const fechaEvento = new Date(fechaString);
return fechaEvento < ahora;
});
};
const tiposSimples = ['demostraciones', 'degustaciones'];
const getStyles = (tipo, tieneImagen, imagenUrl) => {
if (tieneImagen) {
return {
background: { backgroundImage: `url(${imagenUrl})`, backgroundColor: 'transparent' },
text: '#ffffff',
icon: '#ffffff',
};
}
if (tipo === 'degustaciones') {
return {
background: { backgroundImage: 'none', backgroundColor: '#a58d70' },
text: '#2d193b',
icon: '#2d193b',
};
}
if (tipo === 'demostraciones') {
return {
background: { backgroundImage: 'none', backgroundColor: '#2d193b' },
text: '#a58d70',
icon: '#a58d70',
};
}
return {
background: { backgroundImage: 'none', backgroundColor: '#f0f0f0' },
text: '#333',
icon: '#333',
};
};
const RenderIcono = ({ tipo, tieneImagen, imagenUrl }) => {
const { icon: color } = getStyles(tipo, tieneImagen, imagenUrl);
const style = { height: '25px', marginTop: '2px', fill: color, overflow:'visible' };
switch (tipo) {
case 'demostraciones':
return <MenuIcon style={style} />;
case 'degustaciones':
return <MiembrosIcon style={style} />;
case 'eventos':
default:
return <EventosIcon style={style} />;
}
};
const RenderIconoReciente = ({ tipo }) => {
const style = { height: "15px", marginTop: "2px", overflow:'visible' };
switch (tipo) {
case 'demostraciones':
return <MenuIcon style={style} />;
case 'degustaciones':
return <MiembrosIcon style={style} />;
case 'eventos':
default:
return <EventosIcon style={style} />;
}
};
return (
<div className="Trazabilidad">
{isLoading || !imagesLoaded ? (
<LoadingSpinner />
) : (
<>
<header className="trazabilidad-header">
<div className="header-content">
<h1>Eventos</h1>
</div>
</header>
{eventos.length === 0 ? (
<EmptyState label="eventos" />
) : (
<div className="trazabilidad-content">
<div className="section">
<h2>Recientes</h2>
<div className="recent-grid">
{recientes.map((evento) => (
<div
key={evento.id}
className={`document-card recent-card ${evento.tipo}`}
style={{
flexDirection: "row",
textAlign: "left",
alignItems: "start",
justifyContent: "start",
gap: "10px",
padding: "5px 10px",
cursor: "pointer",
}}
onClick={() => {
    // --- INICIO DE CAMBIOS PARA EVENTOS RECIENTES AQUÍ ---
    const isFinished = todasLasFechasPasaron(evento.fechas);
    
    if (evento.tipo === 'degustaciones') {
        // Degustaciones siempre van a editar
        handleEditClick(evento.id, evento.tipo);
    } else if (isFinished) {
        // Si el evento/demostración está terminado (pasado), va a Post mortem/Detalles
        evento.tipo === 'eventos' 
            ? handleEventClick(evento.id) // /eventos/:id (Post mortem)
            : handleSimpleDocClick(evento.id, evento.tipo); // /demostraciones/:id (Post mortem)
    } else {
        // Si el evento/demostración no ha terminado (futuro), va a Editar
        handleEditClick(evento.id, evento.tipo);
    }
    // --- FIN DE CAMBIOS PARA EVENTOS RECIENTES AQUÍ ---
}}
>
{}
<RenderIconoReciente tipo={evento.tipo} />
<div className="card-content" style={{ gap: "0" }}>
<span
style={{
display: "inline-block",
maxWidth: "220px",
overflow: "hidden",
textOverflow: "ellipsis",
whiteSpace: "nowrap",
textAlign: "left",
fontSize: "14px",
margin: 0,
}}
className="doc-id"
>
{evento.titulo}
</span>
<p
className="card-creator"
style={{ textAlign: "left", margin: "0" }}
>
{evento.ultimaActualizacion
? evento.ultimoModificador || "Sin modificador"
: evento.creador || "Sin creador"}
</p>
<p className="card-date" style={{ textAlign: "left", margin: "0" }}>
{formatearFecha(evento.ultimaActualizacion || evento.fechaCreacion)}
</p>
</div>
</div>
))}
</div>
</div>
<div className="section proximos-section">
<h2>Próximos eventos</h2>
<div className="eventos-grid">
{eventos
.filter((evento) => evento.fechas && evento.fechas.length > 0)
.sort((a, b) => {
const fechaA = new Date(a.fechas[0]);
const fechaB = new Date(b.fechas[0]);
return fechaA - fechaB;
})
.map((evento) => {
const styles = getStyles(evento.tipo, !!evento.imagen, evento.imagen);
return (
<div
key={evento.id}
className={`evento-card ${evento.tipo} ${!evento.imagen ? 'simple-card' : ''}`}
style={styles.background}
>
{evento.tipo === 'eventos' && todasLasFechasPasaron(evento.fechas) && (
evento.finished === true ? (
<GreenCheck style={{ position: 'absolute', top: '0', left: '3.5%', height: '65%', fill: '#ffffff' }} />
) : (
<RedCheck style={{ position: 'absolute', top: '0', left: '3.5%', height: '65%', fill: '#ffffff' }} />
)
)}
<div className="evento-columna fechas-precio" style={{height:'85%'}}>
<div style={{display:'flex', flexDirection:'row', alignItems:'start', gap:'30px'}}>
{}
<RenderIcono tipo={evento.tipo} tieneImagen={!!evento.imagen} imagenUrl={evento.imagen} />
{evento.fechas && evento.fechas.length > 0 ? (
<p className="evento-data" style={{color: styles.text}}>
{formatearFechasYHora(evento.fechas, evento.hora)}
</p>
) : (
<p style={{color: styles.text}}>-</p>
)}</div>
<div style={{display:'flex', flexDirection:'row', alignItems:'center', gap:'30px', }}>
{evento.tipo === 'eventos' ? (
<>
<VentasIcon style={{ height: 'auto',margin:'2px',width: '20px', fill: styles.icon }} />
<p className="evento-data" style={{color: styles.text}}>${formatearPrecio(evento.precio) || "-"}</p>
</>
) : evento.tipo === 'demostraciones' ? (
<>
<ClientesIcon style={{ height: 'auto',margin:'2px',width: '20px', fill: styles.icon }} />
<p className="evento-data" style={{color: styles.text}}>
{evento.cantidadPlazas ? `${evento.cantidadPlazas} Plazas` : "-"}
</p>
</>
) : (
<p></p>)}
</div>
</div>
<div className="evento-columna titulo-descripcion">
<h2 className="evento-titulo" style={{color: styles.text}}>{evento.titulo}</h2>
{evento.tipo === 'degustaciones' && evento.invitados && (
<p className="evento-descripcion" style={{ color: styles.text, margin: '5px 0 0 0', fontFamily:'Effra' }}>
{`Lugares disponibles: ${8 - evento.invitados.length}`}
</p>
)}
{evento.tipo !== 'degustaciones' && (
<p
className="evento-descripcion"
style={{color: styles.text,
display: evento.tipo === 'demostraciones' ? '-webkit-box' : 'block',
WebkitLineClamp: evento.tipo === 'demostraciones' ? 4 : 'unset',
WebkitBoxOrient: evento.tipo === 'demostraciones' ? 'vertical' : 'unset',
overflow: evento.tipo === 'demostraciones' ? 'hidden' : 'visible',
textOverflow: evento.tipo === 'demostraciones' ? 'ellipsis' : 'clip',
}}
>
{evento.descripcion}
</p>)}
</div>
<div className="evento-columna coleccion">
{evento.coleccion && evento.coleccion.length > 0 && (
<>
<h3 className="coleccion-title" style={{color: styles.text}}>EN ESTA COLECCIÓN</h3>
<ul className="coleccion-list" style={{color: styles.text}}>
{evento.coleccion
.filter((item) => item)
.map((item, i) => (
<li key={i}>{item}</li>
))}
</ul>
</>
)}

{todasLasFechasPasaron(evento.fechas) ? (
    // Lógica para eventos/demostraciones pasadas
    (evento.tipo === 'eventos' || evento.tipo === 'demostraciones') && (
        <button
            className={`postmortem ${evento.finished ? 'finished' : ''}`}
            onClick={() => handleSimpleDocClick(evento.id, evento.tipo)} // Navegar a la vista Post mortem/Detalle
        >
            <ContractIcon style={{ height: '16px', fill: '#ffffff' }} />
            <p>Post mortem</p>
        </button>
    )
) : (
    // Lógica para eventos futuros (editar para CUALQUIER tipo de evento)
    <button
        className={`postmortem`}
        onClick={() => handleEditClick(evento.id, evento.tipo)} // Editar para cualquier tipo de evento futuro
    >
        <p>Editar {evento.tipo === 'eventos' ? 'evento' : evento.tipo === 'demostraciones' ? 'demostración' : 'degustación'}</p>
    </button>
)}

</div>
</div>
);
})}
</div>
</div>
</div>
)}
</>)}
</div>
);
};
export default Eventos;